import { useRef } from 'react';

import HeroSection from './sections/HeroSection';
import BeddingSection from './sections/BeddingSection';
import PillowsSection from './sections/PillowsSection';
import AttuneSection from './sections/AttuneSection';
import LinensSection from './sections/LinensSection';
import WorksSection from './sections/WorksSection';
import MobBathCollectionSection from './sections/MobBathCollectionSection';
import RobesSection from './sections/RobesSection';
import BourbonSection from './sections/BourbonSection';
import SeoCopySection from './sections/SeoCopySection';
import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection promotion={promotion} />
      <BeddingSection />
      <PillowsSection />
      <LinensSection />
      <AttuneSection />
      <WorksSection />
      <RobesSection />
      <MobBathCollectionSection />
      <BourbonSection />
      <SeoCopySection />
    </div>
  );
};

export default Home;
